import { render, staticRenderFns } from "./uid-search-api.vue?vue&type=template&id=31d442d6&"
import script from "./uid-search-api.vue?vue&type=script&lang=js&"
export * from "./uid-search-api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports